import AbstractDispatcher from '@abstracts/AbstractDispatcher';
import { URL } from '@utilities';

export default class Context extends AbstractDispatcher {
    static _instance;

    constructor(data = {}) {
        super();

        Object.assign(this, {data});

        // Singleton
        if (Context._instance) {
            throw new Error('Error: Use Context.instance instead of new.');
        }
        Context._instance = this;

        this._init();
    }

    _init() {
       // we get some default values
       let d = document.documentElement;
       Object.assign(this, {
           _lang: d.getAttribute('lang').substr(0, 2)
       });
    }

    /**
     * Get URL
     * @return {Object}  host, domain, query, hash, ...
     */
    get url() {
        var uri = URL.parse();
        return {
            uri: uri,
            url: uri.protocol + '://' + uri.host + (uri.port ? ':' + uri.port : '') + uri.path,
            host: uri.protocol + '://' + uri.host + (uri.port ? ':' + uri.port : ''),
            query: uri.params
        };
    }

    /**
     * Get specified value if it exists
     *
     * @param {String} value
     * @return {any | null} value if presents, else null
     */
    getValue(value, defaultValue = null) {
        return this.data[value]
            ? this.data[value] : defaultValue;
    }

    /**
     * Get lang from html lang attriute
     *
     * @return {string | null} lang if attribute present, else null
     */
    get lang() {
        return this._lang;
    }

    /**
     * get singleton instance
     * @returns { Context }  instance's Context
     */
    static get instance() {
        return Context._instance;
    }
}
